export const PERIOD_INDEX = 14;
export const FIRST_DIGIT_INDEX = 0;
export const SECOND_DIGIT_INDEX = 7;
export const THIRD_DIGIT_INDEX = 15;
export const FOURTH_DIGIT_INDEX = 22;

enum Sticks {
  BOTTOM,
  BOTTOM_LEFT,
  BOTTOM_RIGHT,
  MIDDLE,
  TOP,
  TOP_LEFT,
  TOP_RIGHT,
}

// element to be omitted
export const DIGIT_ELEMENT: Sticks[][] = [
  // 0 does not have the middle element
  [Sticks.MIDDLE],
  [
    Sticks.BOTTOM,
    Sticks.MIDDLE,
    Sticks.TOP,
    Sticks.BOTTOM_LEFT,
    Sticks.TOP_LEFT,
  ],
  [Sticks.TOP_LEFT, Sticks.BOTTOM_RIGHT],
  [Sticks.BOTTOM_LEFT, Sticks.TOP_LEFT],
  [Sticks.TOP, Sticks.BOTTOM, Sticks.BOTTOM_LEFT],
  [Sticks.TOP_RIGHT, Sticks.BOTTOM_LEFT],
  // 6
  [Sticks.TOP_RIGHT],
  [Sticks.TOP_LEFT, Sticks.BOTTOM_LEFT, Sticks.BOTTOM, Sticks.MIDDLE],
  // 8
  [],
  [Sticks.BOTTOM_LEFT],
];

export const LEFT_FULL_PATH = [
  'M341.148 569.448L351.036 559.08H374.748L384.06 569.448H341.148Z',
  'M338.268 522.312L348.636 532.296V555.816L338.268 565.224V522.312Z',
  'M387.132 565.224L376.764 555.336V531.72L387.132 522.312V565.224Z',
  'M349.404 525.768C347.164 523.976 344.892 522.216 342.588 520.488L349.404 515.4H375.612L382.332 520.488L375.612 525.768H349.404Z',
  'M341.052 471.912H383.964L374.46 482.28H350.94L341.052 471.912Z',
  'M337.98 518.952V476.04L348.348 485.352V509.16L337.98 518.952Z',
  'M386.844 476.04V518.952L376.476 509.64V485.928L386.844 476.04Z',
  'M417.93 569.448L427.818 559.08H451.53L460.842 569.448H417.93Z',
  'M415.049 522.312L425.418 532.296V555.816L415.049 565.224V522.312Z',
  'M463.914 565.224L453.546 555.336V531.72L463.914 522.312V565.224Z',
  'M426.186 525.768C423.946 523.976 421.674 522.216 419.37 520.488L426.186 515.4H452.394L459.114 520.488L452.394 525.768H426.186Z',
  'M417.834 471.912H460.746L451.242 482.28H427.722L417.834 471.912Z',
  'M414.762 518.952V476.04L425.13 485.352V509.16L414.762 518.952Z',
  'M463.626 476.04V518.952L453.258 509.64V485.928L463.626 476.04Z',
  'M477.719 555.24H489.815V567.528H477.719V555.24Z',
  'M504.273 569.448L514.161 559.08H537.873L547.185 569.448H504.273Z',
  'M501.393 522.312L511.761 532.296V555.816L501.393 565.224V522.312Z',
  'M550.257 565.224L539.889 555.336V531.72L550.257 522.312V565.224Z',
  'M512.529 525.768C510.289 523.976 508.017 522.216 505.713 520.488L512.529 515.4H538.737L545.457 520.488L538.737 525.768H512.529Z',
  'M504.177 471.912H547.089L537.585 482.28H514.065L504.177 471.912Z',
  'M501.105 518.952V476.04L511.473 485.352V509.16L501.105 518.952Z',
  'M549.969 476.04V518.952L539.601 509.64V485.928L549.969 476.04Z',
  'M581.055 569.448L590.943 559.08H614.655L623.967 569.448H581.055Z',
  'M578.174 522.312L588.543 532.296V555.816L578.174 565.224V522.312Z',
  'M627.039 565.224L616.671 555.336V531.72L627.039 522.312V565.224Z',
  'M589.311 525.768C587.071 523.976 584.799 522.216 582.495 520.488L589.311 515.4H615.519L622.239 520.488L615.519 525.768H589.311Z',
  'M580.959 471.912H623.871L614.367 482.28H590.847L580.959 471.912Z',
  'M577.887 518.952V476.04L588.255 485.352V509.16L577.887 518.952Z',
  'M626.751 476.04V518.952L616.383 509.64V485.928L626.751 476.04Z',
];

export const MIDDLE_FULL_PATH = [
  'M818.148 569.448L828.036 559.08H851.748L861.06 569.448H818.148Z',
  'M815.268 522.312L825.636 532.296V555.816L815.268 565.224V522.312Z',
  'M864.132 565.224L853.764 555.336V531.72L864.132 522.312V565.224Z',
  'M826.404 525.768C824.164 523.976 821.892 522.216 819.588 520.488L826.404 515.4H852.612L859.332 520.488L852.612 525.768H826.404Z',
  'M818.052 471.912H860.964L851.46 482.28H827.94L818.052 471.912Z',
  'M814.98 518.952V476.04L825.348 485.352V509.16L814.98 518.952Z',
  'M863.844 476.04V518.952L853.476 509.64V485.928L863.844 476.04Z',
  'M894.93 569.448L904.818 559.08H928.53L937.842 569.448H894.93Z',
  'M892.049 522.312L902.418 532.296V555.816L892.049 565.224V522.312Z',
  'M940.914 565.224L930.546 555.336V531.72L940.914 522.312V565.224Z',
  'M903.186 525.768C900.946 523.976 898.674 522.216 896.37 520.488L903.186 515.4H929.394L936.114 520.488L929.394 525.768H903.186Z',
  'M894.834 471.912H937.746L928.242 482.28H904.722L894.834 471.912Z',
  'M891.762 518.952V476.04L902.13 485.352V509.16L891.762 518.952Z',
  'M940.626 476.04V518.952L930.258 509.64V485.928L940.626 476.04Z',
  'M954.719 555.24H966.815V567.528H954.719V555.24Z',
  'M981.273 569.448L991.161 559.08H1014.87L1024.19 569.448H981.273Z',
  'M978.393 522.312L988.761 532.296V555.816L978.393 565.224V522.312Z',
  'M1027.26 565.224L1016.89 555.336V531.72L1027.26 522.312V565.224Z',
  'M989.529 525.768C987.289 523.976 985.017 522.216 982.713 520.488L989.529 515.4H1015.74L1022.46 520.488L1015.74 525.768H989.529Z',
  'M981.177 471.912H1024.09L1014.59 482.28H991.065L981.177 471.912Z',
  'M978.105 518.952V476.04L988.473 485.352V509.16L978.105 518.952Z',
  'M1026.97 476.04V518.952L1016.6 509.64V485.928L1026.97 476.04Z',
  'M1058.05 569.448L1067.94 559.08H1091.65L1100.97 569.448H1058.05Z',
  'M1055.17 522.312L1065.54 532.296V555.816L1055.17 565.224V522.312Z',
  'M1104.04 565.224L1093.67 555.336V531.72L1104.04 522.312V565.224Z',
  'M1066.31 525.768C1064.07 523.976 1061.8 522.216 1059.49 520.488L1066.31 515.4H1092.52L1099.24 520.488L1092.52 525.768H1066.31Z',
  'M1057.96 471.912H1100.87L1091.37 482.28H1067.85L1057.96 471.912Z',
  'M1054.89 518.952V476.04L1065.25 485.352V509.16L1054.89 518.952Z',
  'M1103.75 476.04V518.952L1093.38 509.64V485.928L1103.75 476.04Z',
];

export const RIGHT_FULL_PATH = [
  'M1295.15 569.448L1305.04 559.08H1328.75L1338.06 569.448H1295.15Z',
  'M1292.27 522.312L1302.64 532.296V555.816L1292.27 565.224V522.312Z',
  'M1341.13 565.224L1330.76 555.336V531.72L1341.13 522.312V565.224Z',
  'M1303.4 525.768C1301.16 523.976 1298.89 522.216 1296.59 520.488L1303.4 515.4H1329.61L1336.33 520.488L1329.61 525.768H1303.4Z',
  'M1295.05 471.912H1337.96L1328.46 482.28H1304.94L1295.05 471.912Z',
  'M1291.98 518.952V476.04L1302.35 485.352V509.16L1291.98 518.952Z',
  'M1340.84 476.04V518.952L1330.48 509.64V485.928L1340.84 476.04Z',
  'M1371.93 569.448L1381.82 559.08H1405.53L1414.84 569.448H1371.93Z',
  'M1369.05 522.312L1379.42 532.296V555.816L1369.05 565.224V522.312Z',
  'M1417.91 565.224L1407.55 555.336V531.72L1417.91 522.312V565.224Z',
  'M1380.19 525.768C1377.95 523.976 1375.67 522.216 1373.37 520.488L1380.19 515.4H1406.39L1413.11 520.488L1406.39 525.768H1380.19Z',
  'M1371.83 471.912H1414.75L1405.24 482.28H1381.72L1371.83 471.912Z',
  'M1368.76 518.952V476.04L1379.13 485.352V509.16L1368.76 518.952Z',
  'M1417.63 476.04V518.952L1407.26 509.64V485.928L1417.63 476.04Z',
  'M1431.72 555.24H1443.81V567.528H1431.72V555.24Z',
  'M1458.27 569.448L1468.16 559.08H1491.87L1501.19 569.448H1458.27Z',
  'M1455.39 522.312L1465.76 532.296V555.816L1455.39 565.224V522.312Z',
  'M1504.26 565.224L1493.89 555.336V531.72L1504.26 522.312V565.224Z',
  'M1466.53 525.768C1464.29 523.976 1462.02 522.216 1459.71 520.488L1466.53 515.4H1492.74L1499.46 520.488L1492.74 525.768H1466.53Z',
  'M1458.18 471.912H1501.09L1491.59 482.28H1468.07L1458.18 471.912Z',
  'M1455.11 518.952V476.04L1465.47 485.352V509.16L1455.11 518.952Z',
  'M1503.97 476.04V518.952L1493.6 509.64V485.928L1503.97 476.04Z',
  'M1535.05 569.448L1544.94 559.08H1568.65L1577.97 569.448H1535.05Z',
  'M1532.17 522.312L1542.54 532.296V555.816L1532.17 565.224V522.312Z',
  'M1581.04 565.224L1570.67 555.336V531.72L1581.04 522.312V565.224Z',
  'M1543.31 525.768C1541.07 523.976 1538.8 522.216 1536.49 520.488L1543.31 515.4H1569.52L1576.24 520.488L1569.52 525.768H1543.31Z',
  'M1534.96 471.912H1577.87L1568.37 482.28H1544.85L1534.96 471.912Z',
  'M1531.89 518.952V476.04L1542.25 485.352V509.16L1531.89 518.952Z',
  'M1580.75 476.04V518.952L1570.38 509.64V485.928L1580.75 476.04Z',
];
